import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoginSessionService {

  public loginSession: string;

  constructor() {
  }
}
